module.exports = __webpack_public_path__ + "img/5c.45af74a6.png";